import React from 'react';
import { MDBBreadcrumb, MDBBreadcrumbItem, MDBContainer,} from 'mdb-react-ui-kit';
import { Link } from 'react-router-dom';

export default function Breadcrumb() {
  return (
   
      <MDBContainer fluid>
        <MDBBreadcrumb>
          <MDBBreadcrumbItem>
            <Link to='/list-manufacturer'>list-manufacturer</Link>
          </MDBBreadcrumbItem>
          <MDBBreadcrumbItem>
            <Link to='/add-manufacturer'>add-manufacturer</Link>
          </MDBBreadcrumbItem>
        </MDBBreadcrumb>
      </MDBContainer>
    
  );
}